import { usePropertyRentalIsAcquisitionFinancing } from '../../../../queries/PropertyFields/RentalFlagFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components/';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';
import { ButtonGroupTypes } from 'devextreme-react/button-group';

interface AcquisitionFinancingRentalProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const AcquisitionFinancingRental: React.FC<AcquisitionFinancingRentalProps> = ({
    propertyGuid,
    required = false,
    isReview = false,
}) => {
    const label = 'Is acquisition funding required at closing?';
    const [isAcquisitionFinancingRental, set_isAcquisitionFinancingRental] =
        usePropertyRentalIsAcquisitionFinancing(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        set_isAcquisitionFinancingRental(e?.itemData.id === 'Yes');
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={isAcquisitionFinancingRental ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='acquisitionFinancingRentalRentalToggleButton'
                    value={isAcquisitionFinancingRental}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='This field is required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
